var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "24px",
    viewBox: "0 0 20 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Project-Editor-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,19 C7,19.552 6.552,20 6,20 C5.448,20 5,19.552 5,19 L5,9 C5,8.448 5.448,8 6,8 C6.552,8 7,8.448 7,9 L7,19 Z M11,19 C11,19.552 10.552,20 10,20 C9.448,20 9,19.552 9,19 L9,9 C9,8.448 9.448,8 10,8 C10.552,8 11,8.448 11,9 L11,19 Z M15,19 C15,19.552 14.552,20 14,20 C13.448,20 13,19.552 13,19 L13,9 C13,8.448 13.448,8 14,8 C14.552,8 15,8.448 15,9 L15,19 Z M20,2 L20,4 L0,4 L0,2 L5.711,2 C6.611,2 7.342,0.901 7.342,0 L12.657,0 C12.657,0.901 13.387,2 14.288,2 L20,2 Z M17,6 L17,22 L3,22 L3,6 L1,6 L1,24 L19,24 L19,6 L17,6 Z",
    id: "Shape",
    fill: "#868686",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.f6e3cb8e.svg";
export { ForwardRef as ReactComponent };